import React from 'react';
import './contact.css';

const ContactForm = ({ formData, formStatus, handleInputChange, handleFormSubmit }) => {
  return (
    <div
      id="contact"
      className="contact-section-bg"
      style={{ background: "url('/contact-bg.jpg') center/cover no-repeat" }}
    >
      <div className="contact-bg-mask"></div>
      <div className="contact-section">
        <div className="contact-email">
          {/* <span className="contact-icon" aria-label="mail">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" fill="none"/>
              <path d="M4 8C4 6.89543 4.89543 6 6 6H26C27.1046 6 28 6.89543 28 8V24C28 25.1046 27.1046 26 26 26H6C4.89543 26 4 25.1046 4 24V8Z" stroke="#111" strokeWidth="2"/>
              <path d="M4 8L16 18L28 8" stroke="#111" strokeWidth="2"/>
            </svg>
          </span> */}
          <a href="mailto:contact@blublutech.com" className="contact-mail">contact@blublutech.com</a>
        </div>
        <form className="contact-form" onSubmit={handleFormSubmit}>
          <input 
            type="text" 
            name="name"
            className="contact-input" 
            placeholder="YOUR NAME *" 
            value={formData.name}
            onChange={handleInputChange}
            required 
          />
          <input 
            type="email" 
            name="email"
            className="contact-input" 
            placeholder="YOUR EMAIL *" 
            value={formData.email}
            onChange={handleInputChange}
            required 
          />
          <textarea 
            name="message"
            className="contact-input contact-message" 
            placeholder="YOUR MESSAGE..." 
            rows="4" 
            value={formData.message}
            onChange={handleInputChange}
            required
          ></textarea>
          {formStatus.submitted && (
            <div className={`form-status ${formStatus.success ? 'success' : 'error'}`}>
              {formStatus.message}
            </div>
          )}
          <button type="submit" className="contact-btn">
            {formStatus.submitted && formStatus.success ? '消息已发送！' : 'Talk To Us'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm; 